module.exports = __webpack_public_path__ + "img/chair_2.a20d4442.png";